import { BaseDict } from "../../blocks/EventListPresenter/dict";

export const getDictPhrase = (dict: BaseDict, key: string) => {
    return dict[key] || key;
}